export default __webpack_public_path__ + "static/media/1598120667945.b16184a0.jpg";